export default __webpack_public_path__ + "static/media/Stamp4.2c24bc0e.svg";